import styled from '@emotion/styled';
import media from '@shared/mediaQuery';
import { getStaticImageUrl } from '@utils/createImageUrl';

const FursysTopStyle = styled('div')`
  ${media.desktop} {
    width: 100%;
    background: url(${getStaticImageUrl({ fileName: 'fursys-main.png' })}) no-repeat top center,
      linear-gradient(90deg, #d8d7d5 50%, #bbbab5 50%);
    background-size: 1920px 100%;
    padding-bottom: 98px;
  }
  ${media.mobile} {
    width: 100%;
    height: 1083px;
    background: url(${getStaticImageUrl({ fileName: 'mobile-fursys-main.png' })}) no-repeat top center,
      linear-gradient(90deg, #d8d7d5 50%, #bbbab5 50%);
    background-size: 100% 1233px;
    padding-bottom: 49px;
  }
  .fursysTop {
    margin: auto;
    text-align: center;
    ${media.desktop} {
      padding-top: 99px;
      max-width: 1080px;
      width: 100%;
    }
    ${media.mobile} {
      width: 100vw;
      padding-top: 57px;
    }
    &--logoWrapper {
      .fursys-logo {
        width: 85px;
        height: 30px;
        margin-right: 13.5px;
        ${media.mobile} {
          width: 64px;
          height: 22px;
          margin-right: 10px;
        }
      }
      .lawtalk-logo {
        width: 88px;
        height: 16px;
        margin-left: 13.5px;
        ${media.mobile} {
          width: 66px;
          height: 12px;
          margin-left: 10px;
        }
      }
    }

    &--title {
      font-family: 'Pretendard-Regular';
      letter-spacing: -1px;
      color: #443736;
      ${media.desktop} {
        font-size: 48px;
        margin-top: 40px;
        line-height: 60px;
      }
      ${media.mobile} {
        font-size: 34px;
        margin-top: 27px;
        line-height: 45px;
      }
    }
    &--title_bold {
      font-family: 'Pretendard-Bold';
      letter-spacing: -1px;
      color: #443736;
      ${media.desktop} {
        font-size: 48px;
      }
      ${media.mobile} {
        font-size: 34px;
      }
    }
    &--sub_title {
      font-family: 'Pretendard-Regular';
      font-size: 20px;
      letter-spacing: -0.3px;
      color: #725d55;
      margin-top: 21px;
      ${media.mobile} {
        margin-top: 9px;
        font-size: 16px;
        letter-spacing: -0.3px;
      }
    }

    .fursys-content {
      margin-top: 680px;
      ${media.mobile} {
        margin-top: 442px;
      }
      .quotation-right {
        margin-bottom: 25px;
        ${media.mobile} {
          width: 17px;
          height: 13px;
          margin-bottom: 11px;
        }
      }
      .quotation-left {
        margin-top: 25px;
        ${media.mobile} {
          width: 17px;
          height: 13px;
          margin-top: 8px;
        }
      }
      .contentImg {
        width: 412px;
        height: 81px;
        ${media.mobile} {
          width: 323px;
          height: 63px;
        }
      }
      &--main {
        margin-top: 27px;
        font-family: 'Pretendard-Regular';
        font-size: 26px;
        letter-spacing: -0.3px;
        color: #443736;
        line-height: 40px;
        ${media.mobile} {
          margin-top: 18px;
          font-size: 18px;
          line-height: 28px;
        }
      }
      &--main-bold {
        font-family: 'Pretendard-Bold';
        font-size: 26px;
        letter-spacing: -0.3px;
        color: #443736;
        ${media.mobile} {
          font-size: 18px;
        }
      }
    }
  }
`;

export default FursysTopStyle;
